"use client";
import { useLanguage } from "@/app/LanguageContext";
import { collectionLoader } from "@/utils/fetchCollection";
import { useTranslate } from "@/utils/languageTranslation";
import React, { useState, useEffect } from "react";
interface ContactCategory {
  name: string;
}
interface Contact {
  title: string;
  number: string;
  contactCategory: {
    name: string;
  };
}
export const ContactsSection = () => {
  const {t} = useTranslate()
  const {language} = useLanguage()
  const [contactCategories, setContactCategories] = useState<ContactCategory[]>(
    []
  );
  const [contacts, setContacts] = useState<Contact[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await collectionLoader<ContactCategory>(
        "contact-categories",
        language
      );
      setContactCategories(response);
      const contactResponse = await collectionLoader<Contact>("contact-lists",language);
      setContacts(contactResponse);
    };
    fetchData();
  }, []);
  return (
    <section className="py-12 px-6 bg-[#F4F8FB]">

      {/* A three-column layout where the first column takes up half and the other two take up the remaining space */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-[71rem] mx-auto">
        {/* First column (half width on md+) */}
        <div className="md:col-span-2 place-items-center md:place-items-start">
          <p className="mb-1">{t('contact_info')}</p>
          <h2 className="text-lg md:text-3xl font-bold mb-4">
            {t('emergency_numbers')}
          </h2>
        </div>
     {
      contactCategories?.map((category, index) => (
         

        <div key={index} className="p-1.5 md:place-items-end flex flex-col place-items-center">
          <ul className='place-items-center md:place-items-start '>
            <h3 className="font-semibold mb-4 justify-self-start ">{category?.name}</h3>
            {contacts?.map((contact, index) => (
              (contact?.contactCategory?.name == category?.name && <li key={index} className="mb-2">
                <span>{contact?.title}:</span> {contact?.number}
              </li>)
            ))}
          </ul>
        </div>)
      )
    }
     </div>
        {/* Second column (one-quarter width on md+) */}
     
    </section>
  );
};
